import type { ReactNode } from "react";

import { CadastroLabels } from "@/lib/labels";
import { cn } from "@/lib/utils";

const OPTIONS: { value: boolean | null; label: string }[] = [
	{ value: true, label: CadastroLabels.triState.yes },
	{ value: false, label: CadastroLabels.triState.no },
	{ value: null, label: CadastroLabels.triState.unknown },
];

function ariaChecked(value: boolean | null) {
	if (value === null) {
		return "mixed" as const;
	}

	return value;
}

export function TriStateField({
	label,
	labelAction,
	value,
	onChange,
	slot,
}: {
	label: string;
	labelAction?: ReactNode;
	value: boolean | null;
	onChange: (value: boolean | null) => void;
	slot: string;
}) {
	return (
		<div
			role="switch"
			aria-checked={ariaChecked(value)}
			data-slot={slot}
			data-value={String(value)}
			className="flex items-center justify-between gap-3 rounded-md px-1.5 py-2 text-left"
		>
			<span className="flex min-w-0 items-center gap-1.5">
				<span className="min-w-0 break-words text-sm text-foreground">{label}</span>
				{labelAction}
			</span>

			<div className="inline-flex shrink-0 overflow-hidden rounded-md border border-border">
				{OPTIONS.map((option) => (
					<button
						key={option.label}
						type="button"
						data-active={value === option.value}
						onClick={() => onChange(option.value)}
						className={cn(
							"h-11 min-w-10 px-3 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:h-7 md:min-w-0 md:px-2.5",
							value === option.value
								? "bg-primary text-primary-foreground"
								: "bg-card text-foreground/70 hover:bg-secondary hover:text-foreground",
						)}
					>
						{option.label}
					</button>
				))}
			</div>
		</div>
	);
}
